import React from 'react';

export function formatFieldLabel(key) {
  return String(key)
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (c) => c.toUpperCase());
}

export function formatValue(value) {
  if (value == null || value === '') return '—';
  if (typeof value === 'boolean') return value ? 'Yes' : 'No';
  if (Array.isArray(value)) {
    if (value.length === 0) return '—';
    if (typeof value[0] !== 'object') return value.join(', ');
    return null;
  }
  if (typeof value === 'object') return null;
  return String(value);
}

export function EnrichmentAlert({ variant = 'info', children }) {
  return <div className={`enrichment-alert enrichment-alert-${variant}`}>{children}</div>;
}

export function EnrichmentPill({ tone = 'neutral', children }) {
  return <span className={`enrichment-pill enrichment-pill-${tone}`}>{children}</span>;
}

export function EnrichmentFieldGrid({ children, columns = 3 }) {
  return (
    <div className="enrichment-field-grid" style={{ '--enrichment-cols': columns }}>
      {children}
    </div>
  );
}

export function EnrichmentField({ label, value, mono = false, fullWidth = false, children }) {
  if (children) {
    return (
      <div className={`enrichment-field ${fullWidth ? 'enrichment-field-full' : ''}`}>
        <div className="enrichment-field-label">{label}</div>
        <div className="enrichment-field-value">{children}</div>
      </div>
    );
  }
  const formatted = formatValue(value);
  if (formatted == null && typeof value === 'object') {
    return (
      <div className={`enrichment-field ${fullWidth ? 'enrichment-field-full' : ''}`}>
        <div className="enrichment-field-label">{label}</div>
        <pre className="enrichment-inline-json">{JSON.stringify(value, null, 2)}</pre>
      </div>
    );
  }
  return (
    <div className={`enrichment-field ${fullWidth ? 'enrichment-field-full' : ''}`}>
      <div className="enrichment-field-label">{label}</div>
      <div className={`enrichment-field-value ${mono ? 'mono' : ''}`}>{formatted}</div>
    </div>
  );
}

export function EnrichmentSignalList({ items = [] }) {
  if (!items.length) return null;
  return (
    <ul className="enrichment-signal-list">
      {items.map((item, index) => {
        const severity = item.severity || item.level || 'info';
        const title = item.detail || item.signal || item.message || item.type || 'Signal';
        const subtitle = item.signal && item.detail ? item.signal : null;
        return (
          <li key={`${title}-${index}`} className={`enrichment-signal enrichment-signal-${severity}`}>
            <div className="enrichment-signal-title">{title}</div>
            {subtitle && <div className="enrichment-signal-sub">{subtitle}</div>}
          </li>
        );
      })}
    </ul>
  );
}

export function EnrichmentDataTable({ columns, rows, empty = 'No data' }) {
  if (!rows?.length) {
    return <p className="enrichment-empty">{empty}</p>;
  }
  return (
    <div className="enrichment-table-wrap">
      <table className="enrichment-table">
        <thead>
          <tr>
            {columns.map((col) => (
              <th key={col.key}>{col.label}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, index) => (
            <tr key={index}>
              {columns.map((col) => (
                <td key={col.key}>{row[col.key] ?? '—'}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export function EnrichmentSectionIntro({ children }) {
  return <p className="enrichment-section-intro">{children}</p>;
}

export function riskTone(level) {
  const normalized = String(level || '').toLowerCase();
  if (normalized === 'critical' || normalized === 'high') return 'danger';
  if (normalized === 'medium') return 'warning';
  if (normalized === 'low') return 'success';
  return 'neutral';
}

export function voipTone(isVoip) {
  if (isVoip === true) return 'danger';
  if (isVoip === false) return 'success';
  return 'neutral';
}
